import React from "react";
import { Link } from "react-router-dom";
import { Select } from "antd";
import { Button } from "react-bootstrap";

import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../../router/all_routes";

interface CompanyOption {
  value: string;
  label: string;
}

interface Props {
  companies: CompanyOption[];
  activeCompanyKey?: string;
  companiesLoading: boolean;
  onCompanyChange: (companyKey: string) => void;
  onManageCategories: () => void;
  onCreate: () => void;
  createDisabled?: boolean;
}

const filterOption = (input: string, option?: { label: string; value: any }) =>
  (option?.label ?? "").toString().toLowerCase().includes(input.toLowerCase());

const EmailTemplatesHeader: React.FC<Props> = ({
  companies,
  activeCompanyKey,
  companiesLoading,
  onCompanyChange,
  onManageCategories,
  onCreate,
  createDisabled,
}) => (
  <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
    <div className="my-auto mb-2">
      <h2 className="mb-1">Email Templates</h2>
      <nav>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item">
            <Link to={all_routes.adminDashboard}>
              <i className="ti ti-smart-home" />
            </Link>
          </li>
          <li className="breadcrumb-item">Configuration</li>
          <li className="breadcrumb-item active" aria-current="page">
            Email Templates
          </li>
        </ol>
      </nav>
    </div>

    <div className="d-flex align-items-center ms-auto flex-wrap gap-2 mb-2">
      <Select
        showSearch
        filterOption={filterOption}
        style={{ width: 260, minHeight: 38 }}
        placeholder="Select Company"
        value={activeCompanyKey || undefined}
        loading={companiesLoading}
        onChange={onCompanyChange}
        options={companies.map((c) => ({ value: c.value, label: c.label }))}
      />
      <Button
        variant="outline-secondary"
        onClick={onManageCategories}
        disabled={createDisabled}
      >
        <i className="ti ti-category me-1" /> Manage Categories
      </Button>
      <Button
        variant="primary"
        onClick={onCreate}
        disabled={createDisabled}
      >
        <i className="ti ti-plus me-1" /> New Template
      </Button>
      <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
        <div className="head-icons mb-0">
          <CollapseHeader />
        </div>
      </div>
    </div>
  </div>
);

export default EmailTemplatesHeader;
